import { authTokenStorage } from '@/features/auth/external/authTokenStorage';
import { meetingStore } from '@/store/meetingStore';
import { clearBotIdEntriesFromLocalStorage } from '@/utils/bot';

export function clearAuthState() {
  authTokenStorage.clear();
  clearBotIdEntriesFromLocalStorage();
  meetingStore.getState().actions.clearAllConsentSent();
  meetingStore.getState().actions.clearBotAnalysisConfigs();
  sessionStorage.removeItem('auth0_return_url');
}
